module.exports = __webpack_public_path__ + "static/media/20ECE14.6162fbd5.jpg";